export enum SurfaceAction {
    saveToCloud,
    download,
    addToCalendar,
    editAndReply,
    openNewTabAndSaveToCloud,
    openAndEdit,
}
